import { render, staticRenderFns } from "./NoCards.vue?vue&type=template&id=8bc17b58"
import script from "./NoCards.vue?vue&type=script&lang=js"
export * from "./NoCards.vue?vue&type=script&lang=js"
import style0 from "../../shared/sass/saved-cards/no-cards.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports